module.exports = __webpack_public_path__ + "static/media/nextStep.7bddbe5e.mp3";